// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"c0404962","71":"21fa315f","88":"3821922f","296":"08be600f","353":"00fbd860","654":"19c9f1f1","773":"e78c671b"}[chunkId] + ".css";
};